// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GlobalVideoPlayer__container-b8beba:not(.GlobalVideoPlayer__mini-a94a5b) {
  height: 100%;
  width: 100%;
}

.GlobalVideoPlayer__hidden-a3b5c0 {
  display: none;
}

.GlobalVideoPlayer__mini-a94a5b {
  border-radius: 12px;
  position: absolute;
  max-width: 400px;
  max-height: 400px;
  bottom: 16px;
  inset-inline-end: 16px;
  overflow: hidden;
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./src/main/GlobalVideoPlayer/GlobalVideoPlayer.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,UAAA;AACF","sourcesContent":[".container:not(.mini) {\n  height: 100%;\n  width: 100%;\n}\n\n.hidden {\n  display: none;\n}\n\n.mini {\n  border-radius: 12px;\n  position: absolute;\n  max-width: 400px;\n  max-height: 400px;\n  bottom: 16px;\n  inset-inline-end: 16px;\n  overflow: hidden;\n  z-index: 2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `GlobalVideoPlayer__container-b8beba`,
	"mini": `GlobalVideoPlayer__mini-a94a5b`,
	"hidden": `GlobalVideoPlayer__hidden-a3b5c0`
};
module.exports = ___CSS_LOADER_EXPORT___;
